function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVelocityPointsIconCurrencySymbolRed = function SvgVelocityPointsIconCurrencySymbolRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#e10b0a",
    d: "M14.203-.01h1.575q6.348.446 10.569 5.168 3.318 3.905 3.644 9.044v1.575q-.427 6.21-4.987 10.407-3.952 3.468-9.226 3.806h-1.575q-6.21-.427-10.407-4.987-3.469-3.95-3.806-9.226v-1.575q.427-6.21 4.987-10.407Q8.927.327 14.203-.01",
    style: {
      opacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefdfd",
    d: "M14.384 1.282q5.64-.154 9.832 3.563 4.61 4.332 4.472 10.69-.317 5.715-4.472 9.6-4.814 4.218-11.205 3.432-5.646-.927-9.075-5.461-3.234-4.54-2.523-10.095.927-5.645 5.461-9.074 3.355-2.442 7.51-2.655",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10a0a",
    d: "M14.627 1.908q5.384-.047 9.327 3.563 4.442 4.338 4.068 10.569-.492 5.189-4.31 8.691-4.232 3.668-9.852 3.291-5.261-.543-8.752-4.472-3.512-4.175-3.149-9.65.525-5.286 4.472-8.792 3.537-3.005 8.197-3.2Z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M19.492 14.889q-.017.002-.02.02a.8.8 0 0 0 .363 0q.727-.024 1.454-.04v.828q-1.06-.028-2.12-.061a2339 2339 0 0 0-2.887 7.167q-1.403.01-2.806-.02a1632 1632 0 0 0-3.008-7.359q-2.12-.058-4.24-.121a396 396 0 0 1 3.937-.121 1 1 0 0 0 .202-.03 2307 2307 0 0 0-2.423-5.925q1.665-.015 3.331-.01a530 530 0 0 0 2.14 5.855l.162.02a227 227 0 0 0 2.836-.101 1470 1470 0 0 1 2.13-5.765q1.615-.015 3.23-.01a1463 1463 0 0 1-2.281 5.673",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefcfc",
    d: "M23.106 13.496q.187 0 .313.141l.919 1.433q.484.02.969.05.603.196 0 .384a14 14 0 0 1-.969.04 169 169 0 0 0-.979 1.464.5.5 0 0 1-.293.101 109 109 0 0 0 .444-1.615q-.514-.015-1.03-.01a7 7 0 0 1-.585.394q-.034-.037-.01-.081a7 7 0 0 1 .262-.424.25.25 0 0 0 0-.141 5 5 0 0 1-.273-.505.2.2 0 0 1 .121.03 6 6 0 0 0 .485.343q.525.015 1.05.01l-.424-1.615Z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6aead",
    d: "M19.492 14.889q.166.03.343.02a.8.8 0 0 1-.363 0q.004-.018.02-.02",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10c0b",
    d: "M13.577 15.495q1.313.033 2.624.081a554 554 0 0 1-1.312 3.533 399 399 0 0 1-1.312-3.614",
    style: {
      opacity: 1
    }
  }));
};
export default SvgVelocityPointsIconCurrencySymbolRed;